module.exports = __webpack_public_path__ + "image/Max_Grip.png";